import { useTranslation } from "react-i18next";

import { TASK_TYPES } from "shared/types/enums";

import { MainAttributes } from "../types/types";
import { COUNT, REQUESTED_COUNT } from "./constants";
import SingleAttribute from "./SingleAttribute";
import { TaskAttributesProps } from "./types";

const TaskAttributes = ({
    separateAttributes,
    taskType
}: TaskAttributesProps) => {
    const { t } = useTranslation();

    const isRxLog = taskType === TASK_TYPES.RxLog;
    const isRxNmeaLog = taskType === TASK_TYPES.RxNmeaLog;

    const getUpdatedAttributes = () => {
        if (isRxLog || isRxNmeaLog) {
            return separateAttributes.map(attribute =>
                attribute[0] === COUNT
                    ? [REQUESTED_COUNT, attribute[1]]
                    : attribute
            );
        }

        return separateAttributes;
    };

    const updatedAttributes = getUpdatedAttributes() as MainAttributes;

    return (
        <>
            <h4>{t("Table##attributes")}</h4>

            {updatedAttributes.map(([key, value]) => {
                return (
                    <SingleAttribute key={key} keyName={key} value={value} />
                );
            })}
        </>
    );
};

export default TaskAttributes;
